import langMap from "langmap";
import React from "react";

export var languages = [];
Object.keys(langMap).forEach(localeName => {
  var option = {
    localeName,
    friendlyName: langMap[localeName].englishName,
  };
  if (localeName === "en-US") {
    languages.unshift(option);
  } else {
    languages.push(option);
  }
});

export const languageChoices = languages.map(({ localeName, friendlyName }) => (
  <option key={localeName} value={localeName}>
    {friendlyName}
  </option>
));
